import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=0a3303cd&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=ts&"
export * from "./Portfolio.vue?vue&type=script&lang=ts&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=0a3303cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3303cd",
  null
  
)

export default component.exports